import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtMoney, fmtDateTime } from "../lib/format";
import { Link } from "react-router-dom";

export default function Bids() {
  const [bids, setBids] = useState([]);
  useEffect(() => {
    api.get("/bids").then(r => setBids(r.data));
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Activity</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">Bids</h1>
        <p className="text-slate-500 mt-1">All bids visible to you.</p>
      </div>
      <div className="card-base overflow-x-auto">
        <table className="table-base">
          <thead><tr><th>Load</th><th>Amount</th><th>Status</th><th>Notes</th><th>Created</th></tr></thead>
          <tbody>
            {bids.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400">No bids.</td></tr>}
            {bids.map(b => (
              <tr key={b.bid_id} data-testid={`bid-list-${b.bid_id}`}>
                <td><Link to={`/app/loads/${b.load_id}`} className="font-mono text-xs text-navy font-semibold hover:underline">{b.load_id}</Link></td>
                <td className="font-mono font-bold text-navy">{fmtMoney(b.amount)}</td>
                <td><span className={`badge ${b.status}`}>{b.status}</span></td>
                <td className="text-sm text-slate-600">{b.notes || "—"}</td>
                <td className="text-xs text-slate-500">{fmtDateTime(b.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
